import { render } from "./SetPinPage.vue?vue&type=template&id=3e1b9671&scoped=true"
import script from "./SetPinPage.vue?vue&type=script&lang=js"
export * from "./SetPinPage.vue?vue&type=script&lang=js"

import "./SetPinPage.vue?vue&type=style&index=0&id=3e1b9671&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1b9671"]])

export default __exports__